module.exports = __webpack_public_path__ + "img/ball-pink.0ba86e8d.svg";